import { MethodSummary } from "../models/methodSummary";
import { Params } from "../models/params";

export class MethodServiceCordova{

    public getSGConnectEdgeMethods():MethodSummary[]{
      var methods:MethodSummary[] = [
        new MethodSummary("function",
        "addObserver",
        "Registers an observer that returns the state of the user session",
        new Params(["string", "function", "function"],
        ["Observer that triggers on bluetooth state change", "Fires on success", "Fires onerror"],
        ["forState", "success","error"]),
        ""
        ),
        new MethodSummary("function",
        "addObserver",
        "Registers an observer with a key. Returns the state of the user session",
        new Params(["string", "string", "function", "function"],
        ["Observer that triggers on bluetooth state change", "Optional key that is used to register/unregister the observer", "Fires on success", "Fires onerror"],
        ["forState", "key", "success","error"]),
        ""
        ),
        new MethodSummary("function",
        "removeObserver",
        "Filter out below a specified log level.",
        new Params(["String"],
        ["Removes an observer mapped to the specified key."],
        ["key"]),
        ""
        ),
        new MethodSummary("function",
        "removeAllObservers",
        "Filter out below a specified log level.",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("function",
        "createSession",
        "Automatically scans, connects, and then starts a session with the gaming machine. Check player-session and ble-status observable for status.",
        new Params(["string"],
        ["User's card number"],
        ["cardNumber"]),
        ""
        ),
        new MethodSummary("function",
        "endSession",
        "Sends a command to the gaming machine to end the user's session. Check player-session and ble-status observable for status.",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("function Boolean",
        "isPrimaryIdentificationRequired",
        "Checks to see if a primary form of identification is required from the Player for transferring funds.",
        new Params(["function"],
        ["Returns whether primary identification is needed or not"],
        ["response"]),
        "Returns null if it is called before a valid session is created"
        ),
        new MethodSummary("function Boolean",
        "isFundsTransferSupported",
        "Checks if Funds Transfer is supported by the Electronic Gaming Machine",
        new Params(["function"],
        [],
        ["response"]),
        "Returns null if it is called before a valid session is created"
        ),
        new MethodSummary("function",
        "getLastCashout",
        "Gets the last cashout for this player from a previous Gaming Machine.",
        new Params(["function"],
        ["returns SGBalance if available"],
        ["response"]),
        "Returns SGBalance if available, or null if it is called before a valid session is created."
        ),
        new MethodSummary("function",
        "getBalances",
        "Returns the player balance during an active session.",
        new Params(["function"],
        ["account type (EBS, EGM, etc.)", "Callback that fires when balance is available."],
        ["accountType", "onBalanceAvailable"]),
        ""
        ),
        new MethodSummary("function",
        "transferAmount",
        "Returns the player balance during an active session.",
        new Params(["int","string","string","string","string", "string", "function"],
        ["ammount in cents","source of type 'SGAccountType'","destination of type 'SGAccountType'","funds of type 'SGDisposition'","Optional primary identifier e.g CMS Pin", "An optional secondary identifier","Callback that fires when fund transfer has finished."],
        ["cents","source","destination","disposition","primaryIdentifier","secondaryIdentifier","onTransferComplete"]),
        ""
        ),
        new MethodSummary("function Boolean",
        "isSupported",
        "Is BLE supported?",
        new Params([],
        [],
        []),
        "Returns whether or not the phone supports BLE >= Lollipop"
        ),
        new MethodSummary("function",
        "registerLogger",
        "Callback contains any logs that the framework may be outputting",
        new Params(["function"],
        ["Triggers when framework outputs any logs"],
        ["logger"]),
        ""
        ),
        new MethodSummary("function",
        "setLogLevel",
        "Filter out below a specified log level.",
        new Params(["string"],
        ["Specify the log level.  i.e ERROR to only get error logs. WARN to only get error and warning logs"],
        ["level"]),
        ""
        ),
        new MethodSummary("function",
        "enableEncryption",
        "Enables encryption between app and machine",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("function",
        "disableEncryption",
        "Disables encrpytion between app and machine",
        new Params([],
        [],
        []),
        ""
        )
      ]
      return methods;
    }

    public getSGBLEConnectMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("function",
            "addObserver",
            "Registers an observer that returns the state of the user session",
            new Params(["string", "function", "function"],
            ["Observer that triggers on bluetooth state change", "Fires on success", "Fires onerror"],
            ["forState", "success","error"]),
            ""
            ),
            new MethodSummary("function",
            "addObserver",
            "Registers an observer with a key. Returns the state of the user session",
            new Params(["string", "string", "function", "function"],
            ["Observer that triggers on bluetooth state change", "Optional key that is used to register/unregister the observer", "Fires on success", "Fires onerror"],
            ["forState", "key", "success","error"]),
            ""
            ),
            new MethodSummary("function",
            "removeObserver",
            "Filter out below a specified log level.",
            new Params(["String"],
            ["Removes an observer mapped to the specified key."],
            ["key"]),
            ""
            ),
            new MethodSummary("function",
            "removeAllObservers",
            "Filter out below a specified log level.",
            new Params([],
            [],
            []),
            ""
            ),
            new MethodSummary("function",
            "createSession",
            "Automatically scans, connects, and then starts a session with the gaming machine. Check player-session and ble-status observable for status.",
            new Params(["string"],
            ["User's card number"],
            ["cardNumber"]),
            ""
            ),
            new MethodSummary("function",
            "endSession",
            "Sends a command to the gaming machine to end the user's session. Check player-session and ble-status observable for status.",
            new Params([],
            [],
            []),
            ""
            ),
            new MethodSummary("function Boolean",
            "isPrimaryIdentificationRequired",
            "Checks to see if a primary form of identification is required from the Player for transferring funds.",
            new Params(["function"],
            ["Returns whether primary identification is needed or not"],
            ["response"]),
            "Returns null if it is called before a valid session is created"
            ),
            new MethodSummary("function Boolean",
            "isFundsTransferSupported",
            "Checks if Funds Transfer is supported by the Electronic Gaming Machine",
            new Params(["function"],
            [],
            ["response"]),
            "Returns null if it is called before a valid session is created"
            ),
            new MethodSummary("function",
            "getLastCashout",
            "Gets the last cashout for this player from a previous Gaming Machine.",
            new Params(["function"],
            ["returns SGBalance if available"],
            ["response"]),
            "Returns SGBalance if available, or null if it is called before a valid session is created."
            ),
            new MethodSummary("function",
            "getBalances",
            "Returns the player balance during an active session.",
            new Params(["function"],
            ["account type (EBS, EGM, etc.)", "Callback that fires when balance is available."],
            ["accountType", "onBalanceAvailable"]),
            ""
            ),
            new MethodSummary("function",
            "transferAmount",
            "Returns the player balance during an active session.",
            new Params(["int","string","string","string","string", "string", "function"],
            ["ammount in cents","source of type 'SGAccountType'","destination of type 'SGAccountType'","funds of type 'SGDisposition'","Optional primary identifier e.g CMS Pin", "An optional secondary identifier","Callback that fires when fund transfer has finished."],
            ["cents","source","destination","disposition","primaryIdentifier","secondaryIdentifier","onTransferComplete"]),
            ""
            ),
            new MethodSummary("function Boolean",
            "isSupported",
            "Is BLE supported?",
            new Params([],
            [],
            []),
            "Returns whether or not the phone supports BLE >= Lollipop"
            ),
            new MethodSummary("function",
            "registerLogger",
            "Callback contains any logs that the framework may be outputting",
            new Params(["function"],
            ["Triggers when framework outputs any logs"],
            ["logger"]),
            ""
            ),
            new MethodSummary("function",
            "setLogLevel",
            "Filter out below a specified log level.",
            new Params(["string"],
            ["Specify the log level.  i.e ERROR to only get error logs. WARN to only get error and warning logs"],
            ["level"]),
            ""
            ),
            new MethodSummary("function",
            "enableEncryption",
            "Enables encryption between app and machine",
            new Params([],
            [],
            []),
            ""
            ),
            new MethodSummary("function",
            "disableEncryption",
            "Disables encrpytion between app and machine",
            new Params([],
            [],
            []),
            ""
            )
          ]
        return methods;
    }

    public getSGLogCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("",
            "function",
            "Fires when app logs a message",
            new Params(
              ["String"],
              ["JSON String with keys message, level and fromFunction."],
              ["log"]),
            ""
            )
          ]

          return methods;
    }


    public getSGBLEStatusCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("void",
            "function",
            "Fires when bluetooth changes state",
            new Params(
              ["String"],
              ["The current bluetooth state"],
              ["state"]),
            ""
            ),
            new MethodSummary("void",
            "function",
            "Fires if there is a bluetooth related error.",
            new Params(["String"],
            ["JSON string that holds the error type, a localized description, and stack trace if available. Keys are type, localizedDescription and debugInformation"],
            ["error"]),
            ""
            )
          ]

          return methods;
    }

    public getSGSessionStatusCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("void",
            "function",
            "Fires when user session changes state",
            new Params(
              ["String"],
              ["The current user session state"],
              ["state"]),
            ""
            ),
            new MethodSummary("void",
            "function",
            "Fires if there is a user session related error.",
            new Params(["String"],
            ["JSON string that holds the error type, a localized description, and stack trace if available. Keys are type, localizedDescription and debugInformation"],
            ["error"]),
            ""
            )
          ]

          return methods;
    }

    public getSGProxStatusCallBackMethods():MethodSummary[]{
      var methods:MethodSummary[] = [
          new MethodSummary("void",
          "function",
          "Fires when user goes out or in of bluetooth range",
          new Params(
            ["String"],
            ["The current user proximity state (in range / out of range)"],
            ["state"]),
          ""
          ),
          new MethodSummary("void",
          "function",
          "Fires if there is a proximity state related error.",
          new Params(["String"],
          ["JSON string that holds the error type, a localized description, and stack trace if available. Keys are type, localizedDescription and debugInformation"],
          ["error"]),
          ""
          )
        ]

        return methods;
  }

  public getSGPlayerProfileCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "function",
        "Fires when player profile settings come throught the gaming machine",
        new Params(
          ["String"],
          ["The profile settings that became available"],
          ["state"]),
        ""
        ),
        new MethodSummary("void",
        "function",
        "Fires if there is a player profile state related error.",
        new Params(["String"],
        ["JSON string that holds the error type, a localized description, and stack trace if available. Keys are type, localizedDescription and debugInformation"],
        ["error"]),
        ""
        )
      ]

      return methods;
}

  public getSGPlayerBalanceCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "function",
        "Fires when the gaming machine replies with available balances",
        new Params(
          ["String"],
          ["The current bluetooth state"],
        ["balanceString"]),
        "This is a json string with keys accountType of SGAccountType, amountInCents,disposition of type SGDisposition"
        ),
        new MethodSummary("void",
        "function",
        "Fires if there is a balance related error.",
        new Params(["String"],
        ["JSON string that holds the error type, a localized description, and stack trace if available. Keys are type, localizedDescription and debugInformation"],
        ["error"]),
        ""
        )
      ]

      return methods;
}

  public getSGFundTransferCallbackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "function",
        "Fires when the gaming machine completes fund transfer",
        new Params(
          [""],
          [""],
          []),
        ""
        ),
        new MethodSummary("void",
        "function",
        "Fires if funds transfer does not complete",
        new Params(["String"],
        ["JSON string that holds the error type, a localized description, and stack trace if available. Keys are type, localizedDescription and debugInformation"],
        ["error"]),
        ""
        )
      ]

      return methods;
  }

  public getSGFundTransferEdgeCallbackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
      ]

      return methods;
  }

  public getSGQRConnectEdgeMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("static void",
        "initialize",
        "Initializes with settings required for network validation",
        new Params(["SGConfiguration"],
        ["The URL of the mobile app server."],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the QR module. Can register multiple observers",
        new Params(["SGConnectQR.SGQRStatusCallBack"],
        ["Callback that triggers on QR status change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the user session",
        new Params(["SGSessionStatusCallBack"],
        ["Callback that triggers on session state change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "createSession",
        "Automatically scans, connects, and then starts a session with the gaming machine.",
        new Params(["android.app.Activity","String"],
        ["Context", "User card number"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "endSession",
        "Sends a command to the gaming machine to end the user's session.",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("static boolean",
        "isSupported",
        "Is QR supported?",
        new Params([],
        [],
        []),
        "Returns whether or not the phone supports QR scanning capabilities"
        ),
        new MethodSummary("static void",
        "destroyConnection",
        "Needs to call activity's onDestroy in order to do some cleanup",
        new Params(["int","int", "android.content.Intent"],
        ["Request code", "result code", "intent data"],
        []),
        ""
        )
      ]
      return methods;
  }


  public getSGQRConnectMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("static void",
        "initialize",
        "Initializes with settings required for network validation",
        new Params(["SGConfiguration"],
        ["The URL of the mobile app server."],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the QR module. Can register multiple observers",
        new Params(["SGConnectQR.SGQRStatusCallBack"],
        ["Callback that triggers on QR status change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the user session",
        new Params(["SGSessionStatusCallBack"],
        ["Callback that triggers on session state change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "createSession",
        "Automatically scans, connects, and then starts a session with the gaming machine.",
        new Params(["android.app.Activity","String"],
        ["Context", "User card number"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "endSession",
        "Sends a command to the gaming machine to end the user's session.",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("static boolean",
        "isSupported",
        "Is QR supported?",
        new Params([],
        [],
        []),
        "Returns whether or not the phone supports QR scanning capabilities"
        ),
        new MethodSummary("static void",
        "destroyConnection",
        "Needs to call activity's onDestroy in order to do some cleanup",
        new Params(["int","int", "android.content.Intent"],
        ["Request code", "result code", "intent data"],
        []),
        ""
        )
      ]
      return methods;
  }

  public getSGQRStatusCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onUpdate",
        "Fires when QR changes state",
        new Params(
          ["java.lang.Enum"],
          ["The current QR state"],
          []),
        ""
        ),
        new MethodSummary("void",
        "onError",
        "Fires if there is a QR related error.",
        new Params(["SGError"],
        ["Object that holds the error type, a localized description, and stack trace if available."],
        []),
        ""
        )
      ]

      return methods;
}



}
